// extracted by mini-css-extract-plugin
export var button = "docs-notepad--button--a9078";
export var iframe = "docs-notepad--iframe--812cb";
export var loading = "docs-notepad--loading--a8c29";
export var notepad = "docs-notepad--notepad--00834";
export var root = "docs-notepad--root--cb9d6";
export var shown = "docs-notepad--shown--b042e";
export var spinnerOverlay = "docs-notepad--spinner-overlay--85e91";